import { useState } from "react";

import { ChartTypesMap } from "../../Widgets/WidgetSettingsDrawers/ChartSettings";
import DropdownOptionWithIcon from "../../Menus/DropdownOptionWithIcon";
import { ViewTypeData as VTD } from "../AddViewDrawer/ViewTypeSection";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";
import PopoverDropdownMenu from "../../Menus/PopoverDropdownMenu";
import DropdownMenuDivider from "../../Menus/DropdownMenuDivider";
import { RefreshQueryButton } from "./RefreshQueryButton";
import EditableText from "../../../elements/EditableText";
import DotsOptionsMenu from "../../Menus/DotsOptionsMenu";
import InfoToolip from "../../../elements/InfoToolip";
import { AppConfirm } from "../../../utils/PopupUtil";

interface Props {
  section: any;
  onDelete: any;
  onUpdate?: (newSection: any, onSuccess?: any) => void;
  onOpen: any;
  editMode: boolean;
  setSettings: any;
  recordID?: string;
  viewID?: string;
  disableRefresh?: boolean;
}

const ViewTypeData = VTD(false);

const DashboardCardToolbar = ({
  section,
  onDelete,
  onUpdate,
  onOpen,
  editMode,
  setSettings,
  recordID,
  viewID,
  disableRefresh,
}: Props) => {
  const [hovered, setIsHovered] = useState(false);
  const [name, setName] = useState(section.Name);
  const [startEditing, setStartEditing] = useState(false);
  const [editTitleState, setEditTitleState] = useState(false);
  const textColor = "#000000";
  const hidden = section?.Type === "Header";

  if (hidden) return null;

  const openSettings = () => setSettings(section);
  const startEditingName = () => setStartEditing(true);
  const handleNameChange = (newName: string) => setName(newName);

  const saveName = (newName: string) => {
    const newSection = { ...section, Name: newName };
    callFunctionIfExists(onUpdate, newSection);
  };

  return (
    <div
      className="d-flex justify-content-between align-items-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        height: 42,
        background: "white",
      }}
    >
      <div
        className="d-inline-block align-items-center"
        style={{
          width: "calc(100% - 40px)",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
          wordBreak: "break-word",
          color: textColor,
        }}
      >
        <div
          className={`d-flex align-items-center text-truncate w-100 ${
            !editMode && "cursor-pointer pl-1"
          }`}
          onClick={() => {
            if (!editMode && typeof onOpen == "function") {
              onOpen();
            }
          }}
        >
          {!editMode &&
            ((ChartTypesMap as any)[section?.Type]?.icon ||
              ViewTypeData.find((v) => v?.value === section?.Type)?.icon) && (
              <i
                className={`mdi mdi-${
                  (ChartTypesMap as any)[section?.Type]?.icon ||
                  ViewTypeData.find((v) => v.value === section.Type)?.icon
                } ml-3 text-primary`}
                style={{ fontSize: 20, lineHeight: 0.75 }}
              />
            )}
          {editMode && (
            <i
              className="mdi mdi-drag rgl-drag-handle ml-2"
              style={{ fontSize: 22, cursor: "grab" }}
            />
          )}
          <EditableText
            savedText={section.Name}
            text={name}
            onChange={handleNameChange}
            onSave={saveName}
            externalTrigger={startEditing}
            setExternalTrigger={setStartEditing}
            syncEditState={(state) => setEditTitleState(state)}
            disabled={!editMode}
            displayClassName="font-weight-600 text-dark cursor-pointer text-truncate ml-2"
          />
          {section?.Description && !startEditing && !editTitleState && (
            <InfoToolip
              text={section.Description}
              iconCSS="ml-2"
              styles={{ color: textColor }}
            />
          )}
        </div>
      </div>
      <div className="mr-2" style={{ color: textColor }}>
        {editMode ? (
          <WidgetOptions
            section={section}
            onOpen={onOpen}
            startEditingName={startEditingName}
            onDelete={onDelete}
            openSettings={openSettings}
            textColor={textColor}
          />
        ) : hovered && !disableRefresh ? (
          <RefreshQueryButton
            section={section}
            textColor={textColor}
            viewID={viewID}
            recordID={recordID}
          />
        ) : null}
      </div>
    </div>
  );
};
export default DashboardCardToolbar;

function WidgetOptions({
  section,
  onOpen,
  startEditingName,
  onDelete,
  openSettings,
  textColor,
}: {
  section: any;
  onOpen: any;
  startEditingName: any;
  onDelete: any;
  openSettings: any;
  textColor: string;
}) {
  return (
    <DotsOptionsMenu
      id={section.id}
      options={
        <PopoverDropdownMenu>
          <DropdownOptionWithIcon
            name="Full Screen"
            onClick={onOpen}
            icon="mdi mdi-arrow-expand"
          />
          <DropdownMenuDivider />
          <DropdownOptionWithIcon
            name="Rename"
            onClick={startEditingName}
            icon="mdi mdi-pencil"
          />
          <DropdownOptionWithIcon
            name="Settings"
            onClick={openSettings}
            icon="mdi mdi-cog"
          />
          <DropdownOptionWithIcon
            name="Delete"
            onClick={() => {
              AppConfirm({
                title: `Delete "${section?.Name}" Widget?`,
                text: "Are you sure you want to delete this widget. This cannot be undone.",
              }).then((result) => {
                if (!result.isConfirmed) return;

                onDelete(section.id);
              });
            }}
            icon="mdi mdi-delete"
          />
        </PopoverDropdownMenu>
      }
      dotsSize={22}
      dotsPadding="1px 5px"
      placement="autoVerticalEnd"
      iconColor={textColor}
    />
  );
}
